import type { IconProps } from './IconProps';

export const ChevronRightSmallTriangleIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 20}
    height={props.height ?? 20}
    {...props}
  >
    <path
      d="M8.125 12.0646C8.125 13.1048 9.32135 13.6899 10.1424 13.0513L12.7971 10.9865C13.4405 10.4861 13.4405 9.5136 12.7971 9.01316L10.1424 6.94842C9.32135 6.30981 8.125 6.89493 8.125 7.93511V12.0646Z"
      fill="currentColor"
    />
  </svg>
);
